import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

const Gallery = () => {
  const [images, setImages] = useState([]);

  useEffect(() => {
    fetch("https://immaculatenursingkkl.org/iihs/api/get_gallery.php")
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setImages(data.data);
        }
      })
      .catch((err) => console.error("Error loading gallery:", err));
  }, []);

  return (
    <div className="gdlr-core-pbf-sidebar-wrapper" style={{ margin: "30px 0px" }}>
      <div className="gdlr-core-pbf-sidebar-container gdlr-core-container">
        {/* Title */}
        <div className="gdlr-core-title-item text-center">
          <h3 style={{ fontSize: "30px", fontWeight: "600", color: "#000" }}>
            Gallery
          </h3>
        </div>

        {/* Carousel */}
        <div className="gdlr-core-sidebar-item" style={{ padding: "35px 0px" }}>
          <Swiper
            modules={[Navigation, Autoplay]}
            navigation
            autoplay={{ delay: 3000 }}
            loop={true}
            spaceBetween={10}
            breakpoints={{
              0: { slidesPerView: 1 },
              600: { slidesPerView: 2 },
              1000: { slidesPerView: 3 },
            }}
          >
            {images.map((img) => (
              <SwiperSlide key={img.id}>
                <img
                  src={img.image_url}
                  alt={img.caption || "Gallery"}
                  style={{ width: "100%", borderRadius: "8px" }}
                />
                {img.caption && (
                  <p style={{ textAlign: "center", marginTop: "5px" }}>
                    {img.caption}
                  </p>
                )}
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </div>
  );
};

export default Gallery;
